/**
 * Centralized API configuration
 * Uses environment variable for base URL with fallback to localhost for development
 */
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Helper function to construct API URLs
 * @param {string} endpoint - The API endpoint path (with or without leading slash)
 * @returns {string} - Full API URL
 */
export const getApiUrl = (endpoint) => {
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE}${normalizedEndpoint}`;
};
